import { render, staticRenderFns } from "./OrganizationPeerGroupGoalsGuard.vue?vue&type=template&id=0d2967bb&"
import script from "./OrganizationPeerGroupGoalsGuard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPeerGroupGoalsGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports